import { render, staticRenderFns } from "./StatisticsWdTurnoverWdChart.vue?vue&type=template&id=10cf0512&"
import script from "./StatisticsWdTurnoverWdChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnoverWdChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports